import LegalPage from './LegalPage'
import { GRIEVANCE_REDRESSAL } from './legal'

export default function GrievanceRedressalPage() {
  return <LegalPage {...GRIEVANCE_REDRESSAL} />
}
